import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { useCart } from "../context/CartContext";

const NAV = [
  { to: "/projects", label: "Projects" },
  { to: "/commercial", label: "Commercial" },
  { to: "/films", label: "Films" },
  { to: "/exhibitions", label: "Installation views" },
  { to: "/shop", label: "Shop" },
  { to: "/about", label: "Info" },
  { to: "/contact", label: "Contact" },
];

const Sidebar = () => {
  const { count, setOpen } = useCart();
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <>
      {/* Mobile top bar */}
      <header className="md:hidden fixed top-0 left-0 right-0 z-40 bg-[color:var(--paper)]/95 backdrop-blur-[2px] flex items-center justify-between px-6 py-4 border-b border-[color:var(--line)]">
        <Link to="/" className="brand-mark leading-none">Alice Lisi</Link>
        <button onClick={() => setMenuOpen(true)} className="font-serif text-sm" aria-label="Menu">Menu</button>
      </header>

      {/* Desktop left sidebar */}
      <aside className="hidden md:flex fixed top-0 left-0 h-screen w-[280px] px-10 py-10 flex-col justify-between z-40">
        <div>
          <Link to="/" className="brand-mark leading-none">Alice Lisi</Link>
          <nav className="mt-10 flex flex-col gap-1.5">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                className={({ isActive }) => `font-serif text-[15px] tlink ${isActive ? "tlink-active w-max" : ""}`}
              >
                {n.label}
              </NavLink>
            ))}
            <a href="https://www.instagram.com/alicelisi__/" target="_blank" rel="noreferrer" className="font-serif text-[15px] tlink mt-0.5">
              Instagram
            </a>
          </nav>

          <div className="mt-8 flex items-baseline gap-3">
            <button onClick={() => setOpen(true)} className="font-serif text-[15px] tlink">
              Cart <span className="counter text-[color:var(--ink-mute)]">({count})</span>
            </button>
          </div>
        </div>

        <div className="font-serif text-[13px] text-[color:var(--ink-mute)]">
          <p>© 2026 Alice Lisi</p>
          <p className="mt-1">Milano — Italy</p>
        </div>
      </aside>

      {/* Mobile sliding menu */}
      <div
        className={`fixed inset-0 bg-[color:var(--paper)] z-50 transition-opacity duration-300 md:hidden ${
          menuOpen ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"
        }`}
      >
        <div className="px-6 py-4 flex items-center justify-between border-b border-[color:var(--line)]">
          <span className="brand-mark">Alice Lisi</span>
          <button onClick={() => setMenuOpen(false)} className="font-serif text-sm" aria-label="Close">Close</button>
        </div>
        <nav className="px-6 py-8 flex flex-col gap-4">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} onClick={() => setMenuOpen(false)} className="font-serif text-2xl">{n.label}</NavLink>
          ))}
          <a href="https://www.instagram.com/alicelisi__/" target="_blank" rel="noreferrer" onClick={() => setMenuOpen(false)} className="font-serif text-2xl">Instagram</a>
          <button onClick={() => { setMenuOpen(false); setOpen(true); }} className="font-serif text-2xl text-left">
            Cart <span className="counter text-lg text-[color:var(--ink-mute)]">({count})</span>
          </button>
        </nav>
      </div>
    </>
  );
};

export default Sidebar;
